import script from "./ConsultantForProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultantForProfile.vue?vue&type=script&setup=true&lang=js"

import "./ConsultantForProfile.vue?vue&type=style&index=0&id=1268ca4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1268ca4d"]])

export default __exports__